import React from 'react';
import { Box, List, ListItem, Text } from '@qga/roo-ui/components';

import Divider from '@/v2/components/ui/Divider';
import Link from '@/v2/components/ui/Link';

const SUPPORT = {
  AUS_NUMBER: '+61291654336',
  AUS_TEXT: '+61 2 91654336',
  USA_NUMBER: '+18337642167',
  USA_TEXT: '+1 8337642167',
  EUR_NUMBER: '+442072923158',
  EUR_TEXT: '+44 2072923158',
};

const ActivitiesSupport = React.memo(() => {
  return (
    <Box mb="16">
      <Box mb="4" fontSize="xl">
        Qantas Activities Support
      </Box>
      <Divider mb="10" />
      <Box mb="6">Qantas Activities is powered by Viator</Box>
      <Box mb="6">
        <Text fontWeight="bold">Frequently Asked Questions</Text>
        <Box>
          Please review the{' '}
          <Link.Text href="/faq" external>
            FAQs
          </Link.Text>{' '}
          before getting in touch with our team.
        </Box>
      </Box>
      <Box>
        <Text fontWeight="bold">Need to manage your booking?</Text>
        <Box width={['100%', '830px']} mb="6">
          If you logged in to your Qantas Frequent Flyer account when you booked
          your activity, you can manage your booking online
        </Box>
        <Box width={['100%', '830px']} mb="6">
          Alternatively, you can fill out the Viator{' '}
          <Link.Text
            href="https://www.viator.com/support/customer-care"
            external
          >
            online support form
          </Link.Text>{' '}
          or call the Viator support team who can assist with all bookings 24/7
          using the details below
        </Box>
        <List>
          <ListItem mb="1">
            AUS:{' '}
            <Link.Text href={`tel:${SUPPORT.AUS_NUMBER}`}>
              {SUPPORT.AUS_TEXT}
            </Link.Text>
          </ListItem>
          <ListItem mb="1">
            USA:{' '}
            <Link.Text href={`tel:${SUPPORT.USA_NUMBER}`}>
              {SUPPORT.USA_TEXT}
            </Link.Text>
          </ListItem>
          <ListItem mb="0">
            EUR:{' '}
            <Link.Text href={`tel:${SUPPORT.EUR_NUMBER}`}>
              {SUPPORT.EUR_TEXT}
            </Link.Text>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
});

export default ActivitiesSupport;
